const isValidDate = (date, format) => {
  if (!date.match(/^[0-9\\/]+$/)) {
    return false;
  }
  let dateArray = date.split("/");
  let dayfield, monthfield, yearfield = "";
  //Date and month correction
  if (dateArray[0].length === 1) {
      dateArray[0] = "0" + dateArray[0];
  }

  if (dateArray[1] !== undefined && dateArray[1].length === 1) {
      dateArray[1] = "0" + dateArray[1];
  }

  let validDateformat = true;
  let validformat = /^\d{2}\/\d{2}\/\d{4}$/; //Basic check for format validity
  let dayobj = '';
  if (format === "mm/dd/yyyy") {
      if (!validformat.test(date)) {
          validDateformat = false;
      } else { //Detailed check for valid date ranges
          monthfield = date.split("/")[0];
          dayfield = date.split("/")[1];
          yearfield = date.split("/")[2];
          dayobj = new Date(yearfield, monthfield - 1, dayfield);
          if (
              (parseInt(dayobj.getMonth() + 1, 10) !== parseInt(monthfield, 10)) ||
              (parseInt(dayobj.getDate(), 10) !== parseInt(dayfield, 10)) ||
              (parseInt(dayobj.getFullYear(), 10) !== parseInt(yearfield, 10))
          ) {
              validDateformat = false;
          } else {
              validDateformat = true;
          }
      }
  } else if (format === "dd/mm/yyyy") {
      if (!validformat.test(date)) {
          validDateformat = false;
      } else { //Detailed check for valid date ranges
          dayfield = date.split("/")[0];
          monthfield = date.split("/")[1];
          yearfield = date.split("/")[2];
          dayobj = new Date(yearfield, monthfield - 1, dayfield);
          if (parseInt(dayobj.getMonth() + 1, 10) !== parseInt(monthfield, 10) ||
              parseInt(dayobj.getDate(), 10) !== parseInt(dayfield, 10) ||
              parseInt(dayobj.getFullYear(), 10) !== parseInt(yearfield, 10)) {
              validDateformat = false;
          } else {
              validDateformat = true;
          }
      }
  }

  if (validDateformat !== true) {
      return false;
  }

  var today = new Date();
  var birthDate = new Date(dayobj);
  var age = today.getFullYear() - birthDate.getFullYear();
  var m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }

  if(age < 18) {
    return false;
  }

  return true;
}

export default isValidDate;



// WEBPACK FOOTER //
// ./src/components/Common/Validation/validDate.js